import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export default function IntraDayProfileHelp() {
    return (
        <IconTooltip>
            <div>
                This chart is an overview of the symbol&apos;s historical
                trading pattern during the day to help inform timing decisions.
            </div>
            <div>
                It compares today&apos;s volume to the historical volume and
                plots the historical spread and price volatility.
            </div>
            <div>
                Data on this chart is displayed by time bins which can be
                changed in the chart&apos;s configuration <Icon name="cog" />.
            </div>
        </IconTooltip>
    );
}
